var map = {
	"./app-icon.svg": 1748,
	"./caret-right-icon.svg": 1749,
	"./chrome-icon.webp": 1750,
	"./edge-icon.webp": 1751,
	"./firefox-icon.webp": 1752,
	"./opera-icon.webp": 1753,
	"./safari-icon.webp": 1754,
	"./unknown-icon.webp": 1755
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1747;